import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter} from 'react-router-dom';
import "./style/fonts.css";
import "./index.css";
import App from "./App";
// import * as serviceWorker from "./serviceWorker";

//ReactDOM.render(<App />, document.getElementById("root"));
ReactDOM.render(
  <BrowserRouter>
    <App/>
  </BrowserRouter>,
  document.getElementById("root")
  
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below.  this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
